import { render, staticRenderFns } from "./ProjectFilesContainer.vue?vue&type=template&id=0388db68&scoped=true&lang=pug&"
import script from "./ProjectFilesContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectFilesContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFilesContainer.vue?vue&type=style&index=0&id=0388db68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388db68",
  null
  
)

export default component.exports